module.exports = __webpack_public_path__ + "static/media/layer1-box.818aa7c1.png";